<template>
  <transition name="slide-fade">
    <div class="m-side-menu-wrapper">
      <div class="side-menu-header">
        <img src="@/assets/side-menu/btn-close.png" @click="closeSideMenu">
        <div>
          <!-- <span style="margin-right: 30px;" @click="goCashAbout">I/O Cash</span> -->
          <span style="margin-right: 30px;" @click="goFreetrialAbout">무료체험</span>
        </div>
          <!-- <span style="position: relative;" @click="goCampaign"><span class="promotion-period">~9.9</span>프로모션</span> -->
      </div>
      <div class="sidemenu-container">
        <p @click="changePage('switcher')">
          <img style="width: 80px;" src="@/assets/side-menu/side-menu-switcher.png" alt>
        </p>
        <span>Switcher</span>
      </div>
      <div class="sidemenu-container">
        <p @click="changePage('sensorlight')">
          <img style="width: 80px;" src="@/assets/side-menu/sensorlight.png" alt>
        </p>
        <img class="icon-new" src="@/assets/side-menu/new-icon.png" alt="">
        <span>센서등</span>
      </div>
      <div class="sidemenu-container">
        <p @click="changePage('checker')">
          <img style="width: 55px;" src="@/assets/side-menu/side-menu-checker.png" alt>
        </p>
        <span>Checker</span>
      </div>
      <div class="sidemenu-container">
        <p @click="changePage('linker')">
          <img style="width: 80px;" src="@/assets/side-menu/side-menu-linker.png" alt>
        </p>
        <span>Linker</span>
      </div>

      <div class="sns-icons">
        <img style="width: 26px; height: 26px;" src="@/assets/footer/facebook.png" alt>
        <img style="width: 26px; height: 26px;" src="@/assets/footer/instagram.png" alt>
        <img style="width: 26px; height: 26px;" src="@/assets/footer/naver-cafe.png" alt>
        <img style="width: 26px; height: 26px;" src="@/assets/footer/kakao-talk.png" alt>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'side-menu',
  methods: {
    closeSideMenu: function () {
      this.$store.commit('toggleSideMenu')
    },
    changePage: function (product) {
      switch (product) {
        case 'switcher':
          this.closeSideMenu()
          this.$router.push({ name: 'Switcher' })
          break
        case 'linker':
          this.closeSideMenu()
          this.$router.push({ name: 'Linker' })
          break
        case 'checker':
          this.closeSideMenu()
          this.$router.push({ name: 'Checker' })
          break
        /* eslint-disable */
        case 'sensorlight':
          this.closeSideMenu()
          window.location.href = 'https://bit.ly/2NOJS7H'
          kakaoPixel('7169508055421727519').viewContent({
            tag: 'sensorlight'
          })
         /* eslint-enable */
      }
    },
    goFreetrialAbout: function () {
      this.$router.push({ name: 'FreeTrial' })
      this.$store.commit('toggleSideMenu')
    },
    goCashAbout: function () {
      this.$router.push({ name: 'Cash' })
      this.$store.commit('toggleSideMenu')
    },
    goCampaign: function () {
      this.$router.push({ name: 'Promotion' })
      this.$store.commit('toggleSideMenu')
    }
  }
}
</script>

<style scoped>

  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  /*.slide-fade-leave-active {*/
    /*transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);*/
  /*}*/
  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(-100%);
    opacity: 0;
  }

  .m-side-menu-wrapper {
    /* height: 100vh; */
  }
  .m-side-menu-wrapper .sidemenu-container {
    margin: 30px;
    padding: 20px;
    border-bottom: 1pt solid #dee2e5;
    position: relative;
  }
  .m-side-menu-wrapper .sidemenu-container p {
    margin: 0px 0px 8px 0px;
    position: relative;
  }
  .side-menu-header {
    padding: 20px;
    display: flex;
    justify-content: space-between;
  }
  .side-menu-header img {
    width: 19px;
    height: 19px;
  }

  .sns-icons {
    padding: 20px 40px 20px 40px;
    display: flex;
    justify-content: space-around;
  }

  .promotion-period {
    position: absolute;
    bottom: -14px;
    left: 12px;
    font-size: 12px;
  }

  .icon-new {
    width: 26pt;
    position: absolute;
    top: 13px;
    left: 0;
    margin-left: 55%;
  }
</style>



// WEBPACK FOOTER //
// src/components/SideMenu.vue